export default function enumsToSelectOptions (enumMap) {
  return Object.values(enumMap).map(enumItem => ({ label: enumItem.human, value: enumItem.api }))
}
